import React from 'react'
import { Box, Container } from '@mantine/core'
import { TOP_NAV_HEIGHT } from './TopNavBar'
import { PRIMARY_SIDEBAR_WIDTH } from './PrimarySidebarNav'
import { BOTTOM_NAB_HEIGHT } from './BottomNavBar'

type AppShellLayoutProps = {
  desktopNav: boolean;
  children: React.ReactNode;
};

export default function AppShellLayout ({ desktopNav, children }: AppShellLayoutProps) {
  return (
    <Box
      component="main"
      sx={{
        marginTop: TOP_NAV_HEIGHT,
        marginLeft: desktopNav ? PRIMARY_SIDEBAR_WIDTH : 0,
        marginBottom: desktopNav ? 0 : BOTTOM_NAB_HEIGHT,
        display: 'flex',
        flexDirection: 'column',
        minHeight: desktopNav
          ? `calc(100vh - ${TOP_NAV_HEIGHT}px)`
          : `calc(100vh - ${TOP_NAV_HEIGHT}px - ${BOTTOM_NAB_HEIGHT}px)`
      }}
    >
      <Container
        size="xl"
        sx={{
          flex: 1,
          paddingTop: 16,
          paddingBottom: 24
        }}
      >
        {children}
      </Container>
    </Box>
  )
}
